var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:{'main_wrapper':_vm.is_in_main(), 'pages_wrapper': !_vm.is_in_main()}},[(!_vm.is_in_referal())?_c('nav_panel',{staticStyle:{"position":"fixed","z-index":"3","top":"0","width":"100%"}}):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('ScrollToTop')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }